import HolifyaFullLogo from "@/components/HolifyaFullLogo"
import MenuButton from "@/components/ui/MenuButton"
import { useCreateEvent } from "@/features/events/hooks/useCreateEvent"
import { EventType } from "@/features/events/types/EventType"
import BackButton from "@/pages/new-platform/components/BackButton"
import { useMenuStore } from "@/utils/stores/useMenuStore"
import { useUserStore } from "@/utils/stores/useUserStore"
import { MenuIcon } from "lucide-react"
import { useCallback } from "react"
import { useNavigate } from "react-router-dom"
import { ElementImportance } from "../types/ElementImportance"

interface Props {
    importance: ElementImportance,
    title?: string,
    backTo?: string,
    backButtonText?: string,
}
const MobileTopBar: React.FC<Props> = ({
    importance,
    title,
    backTo,
    backButtonText,
}) => {
    const { userData } = useUserStore()
    const { openMenu } = useMenuStore()
    const navigate = useNavigate()
    const { sendEvent } = useCreateEvent()

    const handleMenuClick = useCallback(() => {
        openMenu();
    }, [openMenu]);

    const handleBackClick = useCallback(() => {
        if (backTo) {
            navigate(backTo)
        } else {
            navigate(-1)
        };
        sendEvent({
            event: EventType.BUTTON_CLICK,
            sub_category: "back_button",
        })
    }, [navigate, backTo, sendEvent]);

    return (
        <div className={`w-full flex justify-between ${(importance === ElementImportance.NavBarSubComponent) ? "items-start" : "items-center h-[40px]"}`}>
            <div>
                {importance === ElementImportance.Main && (
                    <div className="w-[70px] md:w-[161px]">
                        <HolifyaFullLogo />
                    </div>
                )}

                {importance === ElementImportance.NavBarComponent && title && (
                    <div className="font-bold text-2xl leading-small">{title}</div>
                )}

                {importance === ElementImportance.NavBarSubComponent && (backTo || title || backButtonText) && (
                    <div className="">
                        <div className="h-[40px] flex items-center">
                            <BackButton onClick={handleBackClick} text={backButtonText || "Indietro"} />
                        </div>
                        <div className="font-bold text-2xl leading-small">{title}</div>
                    </div>
                )}
            </div><div className="flex items-center gap-[10px]">
                {importance === ElementImportance.Main && (
                    <div className="font-bold text-small">{userData.name}</div>
                )}

                {
                    <MenuButton onClick={handleMenuClick} aria-label="Open menu" className="md:hidden">
                        <MenuIcon />
                    </MenuButton>
                }
            </div>
        </div>
    )
}

export default MobileTopBar
